module.exports = __webpack_public_path__ + "static/avatar3-d5f40349fe80fec0be52e90eb66af44a.jpg";